import React from "react";
import { Invest } from "../Cards/Invest";
import { Deposite } from "../Deposite/Deposite";
import Withdraw from "../Withdraw/Withdraw";

export const Wallet = ({ isHome, user }) => {
  return (
    <div>
      {/* Wallet Card */}
      <div
        className="relative mt-6 rounded-2xl px-6 py-4 overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #0052CC 0%, #0A1628 100%)",
        }}
      >
        {/* Decorative circles */}
        <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full opacity-10 bg-white" />
        <div className="absolute -bottom-8 -left-4 w-24 h-24 rounded-full opacity-10 bg-white" />

        <p className="font-body text-xs font-normal text-blue-200 tracking-widest uppercase text-center">
          Total Balance
        </p>

        <h3 className="text-center font-headRegular text-4xl text-white mt-2 tracking-tight">
          ${user.balance ? Number(user.balance).toLocaleString() : "0.00"}
        </h3>

        {/* Action buttons inside card */}
        <div className="flex justify-center gap-x-4 mt-6">
          <Deposite fromWallet={true} />
          <Withdraw fromWallet={true} />
        </div>
      </div>
    </div>
  );
};
